export const CTA_TEXTS = {
    PRIMARY_ONE_V1: "Pay less with Swiggy One",
    PRIMARY_ONE_LITE_V1: "Pay less with One Lite",
    SECONDARY_ONE_V1: "Remove membership",
    SECONDARY_ONE_LITE_V1: "Remove membership",
    PRIMARY_ONE_V2: "Save ₹{0} with One",
    PRIMARY_ONE_LITE_V2: "Save ₹{0} with One Lite",
    SECONDARY_ONE_V2: "Remove One & pay more",
    SECONDARY_ONE_LITE_V2: "Remove One Lite & pay more",
};

export const VARIANT = {
    ANIMATION: "ANIMATION",
};

export const TITLE_PLACEHOLDER = "svg_value";
